import React, { forwardRef } from 'react';
import classNames from 'classnames';

import './_filter-title.scss'
import './_filter-title.dark-mode.scss'

import PropTypes from 'prop-types';
import { UI_NAME } from '../../../utils/config';

const FilterTitle = forwardRef(
  (props, ref) => (
    <div
      className={classNames(`${UI_NAME}-filter-title`, props.className)}
      ref={ref}
    >
      {props.children}
    </div>
  ),
)

FilterTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

export default FilterTitle
